import memoize from 'memoize-one';

const ShiftSummaryReportsColumns = memoize(() => [
  {
    name: 'Razon Social',
    selector: 'company_name',
    sortable: false,
    grow: '2'
  },
  {
    name: 'RUT del Empleador',
    selector: 'company_rut',
    sortable: false,
    grow: '1'
  },
  {
    name: 'Nombre',
    selector: 'name',
    sortable: false,
    grow: '2'
  },

  {
    name: 'RUT Colaborador',
    selector: 'national_identification',
    sortable: false,
    grow: '1'
  },

  {
    name: 'Lugar de Prestación de Servicios',
    selector: 'branch_offices',
    sortable: false,
    grow: '4'
  },



]);

export default ShiftSummaryReportsColumns;
